import { DocumentReview } from 'modules/desktop-review/definitions/applications/entities/document-review.entity';
import { DocumentValidationState } from 'modules/desktop-review/redux/document-validation/index';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import get from 'lodash/get';

export const useNavigateToDocumentReview = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const transformProductToDocumentReview = (productEntity, qualityRequirements) => {
    const documentReviewEntity = DocumentReview.createDocumentReviewByProductEntity({
      ...productEntity,
      qualityRequirements: (qualityRequirements || []).map((req) => {
        return {
          type: get(req, 'data.customType.name'),
          name: get(req, 'data.item.customName.name'),
        };
      }),
    });

    dispatch({
      type: DocumentValidationState.actionTypes.SET_DEFAULT_DOCUMENT_VALIDATION_ATTRIBUTES,
      payload: {
        documentReview: documentReviewEntity,
      },
    });
  };

  const navigateToDocumentReview = (productEntity, qualityRequirements, { isSelfUpLoad }) => {
    transformProductToDocumentReview(productEntity, qualityRequirements);
    const urls = {
      selfUpload: '/document-review/upload-document/create',
      supplierUpload: '/document-review/upload-document/request',
    };
    const url = isSelfUpLoad ? urls.selfUpload : urls.supplierUpload;
    history.push(url);
  };

  return navigateToDocumentReview;
};
